module.exports = "pegasus/assets/themelp1/product/109.png";